import { NavigationItem } from '@cvx/nextpage';

export const APP_ROUTES = {
  HOME: 'home',
  ISSUES: 'issues',
  MAINTENANCE: 'maintenance',
  ALL_ISSUES: 'all',
  FILTER_ISSUES: 'filter',
  NEW_ISSUES: 'newIssues',
  AMENDED_RETURN: 'amendedReturn',
  TAX_ACCOUNTING: 'taxAccounting',
  KEY_WORD: 'keyWord',
  AUDIT_TRAIL: 'auditTrail',
  ENTITIES: 'entities',
  TAX_RATES: 'taxRates',
  USER: 'users',
  ERROR: 'error',
  UNAUTHORIZED: 'unauthorized',
} as const;

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Home',
    link: `/${APP_ROUTES.HOME}`,
  },
  {
    label: 'Issues',
    link: `/${APP_ROUTES.ISSUES}`,
  },
  {
    label: 'Amended Return',
    link: `/${APP_ROUTES.AMENDED_RETURN}`,
  },
  {
    label: 'Tax Accounting (ASC 740-10 Review)',
    link: `/${APP_ROUTES.TAX_ACCOUNTING}`,
  },
  {
    label: 'Maintenance',
    link: `/${APP_ROUTES.MAINTENANCE}`,
  },
  {
    label: 'Users',
    link: `/${APP_ROUTES.USER}`,
  },
];
